




























import { Component, Prop, Vue } from 'vue-property-decorator';
import {
    HalfWidthBlockViewModel,
    PersonalizedContentBlockViewModel,
    TextBlockViewModel
} from '@/types/contentServerContract';
import AdnuntiusPixels from '@/project/tracking/adnuntius/AdnuntiusPixels.vue';
import ImageTextVideoBlock from '@/project/app/blocks/ImageTextVideoBlock.vue';
import ImageTextVideoBlockNew from '@/project/app/blocks/ImageTextVideoBlockNew.vue';
import { AdContentBlockViewModel } from '@/types/apiServerContract';
import adnuntiusService from '@/project/personalization/adnuntius.service';
import TextBlock from './TextBlock.vue';
import JotFormBlock from './JotFormBlock.vue';
import CancelNewsletterBlock from './newsletter/CancelNewsletterBlock.vue';
import GoogleMapsBlock from './google-maps/GoogleMapsBlock.vue';
import { AdnuntiusTrackingData } from '@/project/tracking/adnuntius/types';
import { BlockName } from '@/project/app/blocks/index';
const UniqueSellingPointBlock = () => import(/* webpackPrefetch: true, webpackChunkName: 'basic-blocks' */ './UniqueSellingPointBlock.vue');

const AllowedBlocks: BlockName[] = ['heroBanner', 'personalizedContent', 'halfWidthBlock', 'textBlock', 'jotFormBlock', 'map', 'cancelNewsletterBlock', 'uniqueSellingPointBlock'];

@Component({
    components: { UniqueSellingPointBlock, ImageTextVideoBlock, ImageTextVideoBlockNew, AdnuntiusPixels, TextBlock, JotFormBlock, GoogleMapsBlock, CancelNewsletterBlock }
})
export default class ContentBlockContainer extends Vue {
    private contentLoadError = false;
    private adContentBlockViewModel: AdContentBlockViewModel | null = null;
    private adnuntiusTrackingData: AdnuntiusTrackingData | null = null;

    @Prop({ required: true, type: Object })
    content!: HalfWidthBlockViewModel | PersonalizedContentBlockViewModel | TextBlockViewModel;

    @Prop({ required: true, type: String, validator: (value: string) => AllowedBlocks.includes(value as BlockName) })
    alias!: BlockName;

    @Prop({ required: true, type: String })
    parentAlias!: string;

    @Prop({ required: true, type: Number })
    index!: number;

    private get isHeroBanner(): boolean {
        return this.alias === 'heroBanner';
    }

    private get isAdUnitContent(): boolean {
        return this.alias === 'personalizedContent';
    }

    private get isHalfWidthBlock(): boolean {
        return this.alias === 'halfWidthBlock';
    }

    private get isTextBlock(): boolean {
        return this.alias === 'textBlock';
    }

    private get isJotFormBlock(): boolean {
        return this.alias === 'jotFormBlock';
    }

    private get isMapBlock(): boolean {
        return this.alias === 'map';
    }

    private get isCancelNewsletterBlock(): boolean {
        return this.alias === 'cancelNewsletterBlock';
    }

    private get isUniqueSellingPointBlock(): boolean {
        return this.alias === 'uniqueSellingPointBlock';
    }

    private get renderedPixelUrl() {
        return this.adContentBlockViewModel?.renderedPixelUrl;
    }

    private get viewPixelUrl() {
        return this.adContentBlockViewModel?.viewPixelUrl;
    }

    private get visiblePixelUrl() {
        return this.adContentBlockViewModel?.visiblePixelUrl;
    }

    private get clickPixelUrl() {
        return this.adContentBlockViewModel?.clickPixelUrl;
    }

    private async getAdContent(adUnitId: string) {
        try {
            this.adContentBlockViewModel = await adnuntiusService.getBundledPersonalizedContent(
                adUnitId,
                this.$route.fullPath);

            if (this.adContentBlockViewModel.lineItemId && this.adContentBlockViewModel.creativeId) {
                this.adnuntiusTrackingData = {
                    lineItemId: this.adContentBlockViewModel.lineItemId,
                    creativeId: this.adContentBlockViewModel.creativeId,
                    parentBlockAlias: this.parentAlias
                };
            }
        } catch {
            this.contentLoadError = true;
            this.$emit('contentLoadError');
        }
    }

    private created() {
        if (this.isAdUnitContent) {
            this.getAdContent((this.content as PersonalizedContentBlockViewModel).settings.selectedAdUnitIdContent.adUnitId);
        }
    }
}
